/* Button that closes the current window, which was opened by window.open() in another tab */
$(function () {
    if (window.location.href.indexOf("show-close-btn=true") > -1) {
        $("[data-close-window]").each(function () {
            var $button = $(this);

            $button.closest(".button-wrapper").removeClass("displayNone");
            $button.click(function (e) {
                e.preventDefault();
                window.close();
            });
        });
    }
});
